import React, { useState } from "react";

import { Delivery } from 'typings/models';
import {
    Card,
    CardContent,
    Typography,
    Grid2 as Grid,
    IconButton,
    Modal,
    Box,
    TextField,
    Button
} from '@mui/material';
import { CheckCircle, Cancel,
    BrokenImage,
    Rule,
    Error,
    ControlPointDuplicate,
    Thunderstorm,
    WaterDamage,
     LocalShipping,
     Comment,
    Restore } from '@mui/icons-material';
import { useTravelContext } from 'misc/TravelContext';
import { reopenDelivery, addCommentToDelivery } from 'api/deliveries';
import { formatDateTime } from 'misc/dateUtils';

interface FinishedDeliveryCardProps {
    delivery: Delivery;
}


const FinishedDeliveryCard: React.FC<FinishedDeliveryCardProps> = ({ delivery }) => {

    const [openModal, setOpenModal] = useState(false);
    const deliveryTime = formatDateTime(delivery.updated_at);

    const createdAtDate = new Date(delivery.created_at);
    const updatedAtDate = new Date(delivery.updated_at);
    const timeDiff = Math.abs(new Date().getTime() - createdAtDate.getTime());
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDiff / 1000 / 60) % 60);

    const {  updateDelivery } = useTravelContext();

    const statusCodeMapper = {
        "DAMAGED": <BrokenImage className="status-icon failed-status" />,
        "INCOMPLETE": <Rule className="status-icon failed-status" />,
        "INCORRECT": <Error className="status-icon failed-status" />,
        "DUPLICATE": <ControlPointDuplicate className="status-icon failed-status" />,
        "BAD_WEATHER": <Thunderstorm className="status-icon failed-status" />,
        "WATER_DAMAGE": <WaterDamage className="status-icon failed-status" />,
        "OTHER": <Cancel className="status-icon failed-status" />,
    };

    const statusIconMapper = {
        "Completed": <CheckCircle className="status-icon completed-status" />,
        "Cancelled": <Cancel className="status-icon cancelled-status" />,
        "Failed": <Cancel className="status-icon failed-status" />,
        "In Progress": <LocalShipping className="status-icon in-progress-status" />,
        "Not Started": <LocalShipping className="status-icon not-started-status" />,
    };

    let statusDescription = "Entregado";
    let statusIcon = statusIconMapper[delivery.status as keyof typeof statusIconMapper];
    let statusClass = "completed-status";
    if (delivery.status === "Failed") {
        if (delivery.delivery_comments.length > 0) {
            // order the comments by created_at and get the last one
            const lastComment = delivery.delivery_comments.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0];
            statusDescription = lastComment.comment_code.short_description;
            const statusCode = lastComment.comment_code.code;
            if (Object.keys(statusCodeMapper).includes(statusCode)) {
                statusIcon = statusCodeMapper[statusCode as keyof typeof statusCodeMapper];
                statusClass = "failed-status";
            }
        }
    } 

    const markReopenDelivery = async () => {
        const response = await reopenDelivery(delivery.id);
        if (response) {
            updateDelivery(response);
        }
    }

    const addComment = (comment: string, comment_code_id: string) => {
        addCommentToDelivery(delivery.id, comment, comment_code_id).then((response) => {
            console.log(response);  
            updateDelivery(response);
        });
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    const [comment, setComment] = useState("");

    const modalContent = (
        <Modal
            open={openModal}
            onClose={handleModalClose}
            className="delivery-card__modal"
        >
            <Box className="delivery-card__modal-content">
                <Typography variant="h6" gutterBottom>
                    Agregar Comentario
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Ingrese su comentario"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setComment(e.target.value)}
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={handleModalClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={() => {
                      addComment(comment, "7" );
                      handleModalClose();
                    }}>
                        Guardar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );

    return (
        <Card className="">
            <CardContent>
            <Grid container justifyContent="flex-end">
                <IconButton 
                    sx={{marginTop: "-20px", marginRight: "-10px"}}
                    onClick={markReopenDelivery}
                >
                    <Restore sx={{fontSize: "30px"}}/>
                </IconButton>
                <IconButton sx={{marginTop: "-20px", marginRight: "-20px"}} onClick={() => setOpenModal(true)}>
                    <Comment />
                </IconButton>
            </Grid>
                <Grid container spacing={2} marginTop={"-20px"}>
                    <Grid size={{md:1, sm:4}} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        {statusIcon}
                    </Grid>
                
                    <Grid size={{md:11, sm:8}} >

                        <Typography variant="h6" className="finished-delivery-card__title" fontWeight="bold">
                            {delivery.order.id}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" className={statusClass}>
                            {statusDescription}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                           {deliveryTime}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {hours} h {minutes} m
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
            {modalContent}
        </Card>
    );
};

export default FinishedDeliveryCard;
